import { render, staticRenderFns } from "./ToshinOrder.vue?vue&type=template&id=1bd704c6&"
import script from "./ToshinOrder.vue?vue&type=script&lang=js&"
export * from "./ToshinOrder.vue?vue&type=script&lang=js&"
import style0 from "./ToshinOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports